import reload from "../../../reload";
import setWindowData from "../../../utils/set-window-data";
import WINDOW from "../../../utils/window";
/**
 *
 * @param {Event} e
 */
const onResize = (e) => {
  const resize = /** @type {Number | null} */ (WINDOW.get("resize"));

  if (resize !== null) {
    clearTimeout(resize);
  }

  /** Reset the idle time difference */
  WINDOW.set("raf-difference", 0);

  const time = setTimeout(() => {
    /** Get the old window `width` before the checking for the new window data */
    const oldWidth = WINDOW.get("width");
    const oldHeight = WINDOW.get("height");

    /** Get and set the current window data */
    setWindowData();

    /** Get the new window `width` */
    const newWidth = WINDOW.get("width");
    const newHeight = WINDOW.get("height");

    /** If widths are different, apply reload, because the resolution has changed */
    if (oldWidth !== newWidth) {
      reload(null);
    }
  }, 150);

  WINDOW.set("resize", /** @type {Number} */ (/** @type {unknown} */ (time)));
};

export default onResize;
